import {
    CalendarMonthOutlined,
    SpeedOutlined,
} from "@mui/icons-material";
import dayjs from "dayjs";
import { VehicleAlertSummaryType, VehicleAlertType } from "../types/types";
import NotificationCard from "./NotificationCard";

type VehicleAlertCardProps = {
    vehicle: VehicleAlertSummaryType;
    alert: VehicleAlertType;
};

const VehicleAlertCard = ({ vehicle, alert }: VehicleAlertCardProps) => {
    const category = alert.type === "MAINTENANCE"
        ? "MANUTENÇÃO"
        : alert.type === "OIL_CHANGE"
            ? "TROCA DE ÓLEO"
            : alert.type === "DRIVER_UNAUTHORIZED"
                ? "CONTROLE DE CONDUTORES"
                : alert.type === "IDLE_TIME"
                    ? "TEMPO OCIOSO"
                    : "CHECKLIST";
    const severity = alert.severity === "CRITICAL" ? "CRÍTICO" : "ATENÇÃO";
    const title = alert.title
        ? alert.title.charAt(0).toLocaleUpperCase("pt-BR")
            + alert.title.slice(1).toLocaleLowerCase("pt-BR")
        : "Alerta do veículo";
    const dueOdometer = typeof alert.dueOdometer === "number" ? alert.dueOdometer : null;
    const details = [
        ...(alert.dueDate
            ? [{
                key: "due-date",
                icon: <CalendarMonthOutlined fontSize="small" color="action" />,
                text: `Data prevista: ${dayjs(alert.dueDate).format("DD/MM/YYYY")}`,
            }]
            : []),
        ...(dueOdometer !== null
            ? [{
                key: "due-odometer",
                icon: <SpeedOutlined fontSize="small" color="action" />,
                text: `Hodômetro limite: ${dueOdometer.toLocaleString("pt-BR")} km`,
            }]
            : []),
    ];

    return (
        <NotificationCard
            category={category}
            severity={severity}
            severityColor={alert.severity === "CRITICAL" ? "error" : "warning"}
            title={title}
            subject={`${vehicle.vehicleName} - ${vehicle.vehiclePlate}`}
            message={alert.message}
            details={details}
        />
    );
};

export default VehicleAlertCard;
